import { FoodsIcon, greyTheme } from "@foodpilot/foods";
import { Button, DialogTitle, Typography } from "@mui/material";

type BaseHeaderProps = {
    title: string;
    closeWindow: () => void;
};
export const BaseHeader = (props: BaseHeaderProps) => {
    const { title, closeWindow } = props;
    return (
        <DialogTitle sx={dialogTitleStyles}>
            <Typography variant="h4">{title}</Typography>
            <Button variant="text" endIcon={<FoodsIcon size={2} icon={"close"} />} onClick={closeWindow} />
        </DialogTitle>
    );
};

const dialogTitleStyles = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: `1px solid ${greyTheme[500]}`,
    minHeight: "68px",
    padding: "28px 27px 28px 32px",
};
